function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48 5.647C24.61 5.647 5.647 24.61 5.647 48 5.647 71.39 24.61 90.353 48 90.353c23.39 0 42.353-18.962 42.353-42.353 0-4.873-.822-9.548-2.332-13.897a2.824 2.824 0 015.335-1.853A47.935 47.935 0 0196 48c0 26.51-21.49 48-48 48S0 74.51 0 48 21.49 0 48 0a47.792 47.792 0 0124.002 6.423 2.824 2.824 0 11-2.828 4.888A42.145 42.145 0 0048 5.647z",
  fill: "#F5F5F5"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.158 33.158a2.872 2.872 0 014.062 0l26.573 26.573a2.872 2.872 0 11-4.062 4.062L33.158 37.22a2.872 2.872 0 010-4.062z",
  fill: "#F5F5F5"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.792 33.158a2.872 2.872 0 010 4.061L37.22 63.793a2.872 2.872 0 01-4.061-4.062L59.73 33.158a2.872 2.872 0 014.061 0z",
  fill: "#F5F5F5"
});
function SvgWarningIconMb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default __webpack_public_path__ + "/img/WarningIcon-mb.svg";
export { SvgWarningIconMb as ReactComponent };